import React from 'react';
import './ResponseSection.css';

function formatPhone(raw) {
  if (!raw) return null;
  const d = raw.replace(/\D/g, '');
  // Strip leading country code "1" from 11-digit numbers (Yelp sends "+1 718-555-1234")
  const digits = d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
  if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  return raw;
}

const ResponseSection = ({ restaurant }) => {
  if (!restaurant) return null;

  const address = `${restaurant.building} ${restaurant.street}, ${restaurant.boro}, New York ${restaurant.zipcode}`;
  const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
  const phone = formatPhone(restaurant.phone);

  return (
    <section className="response-section">
      {restaurant.cuisine && (
        <span className="cuisine-badge">{restaurant.cuisine}</span>
      )}

      <h2 className="restaurant-name">{restaurant.name}</h2>

      <div className="restaurant-detail">
        <span className="detail-icon">📍</span>
        <div>
          <p className="detail-line">{restaurant.building} {restaurant.street}</p>
          <p className="detail-line">{restaurant.boro}, New York {restaurant.zipcode}</p>
        </div>
      </div>

      {phone && (
        <div className="restaurant-detail">
          <span className="detail-icon">📞</span>
          <a href={`tel:${restaurant.phone}`} className="detail-phone">{phone}</a>
        </div>
      )}

      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="directions-btn"
      >
        Get Directions ↗
      </a>
    </section>
  );
};

export default ResponseSection;
